module.exports = __webpack_public_path__ + "img/projects-img6.6c4cc116.jpg";